import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Urls } from '@/lib/navigation';
import { trackSettingsOpened } from '@/analytics';
import { isPaperThemeActive } from '@/hooks/useThemeFlag';

export const BillingLinkButton = ({ children }: { children: ReactNode }) => {
  const className = isPaperThemeActive()
    ? 'underline text-[var(--periwinkle)] hover:text-[var(--periwinkle-bold)] cursor-pointer'
    : 'underline hover:text-red-300 cursor-pointer';
  return (
    <Link to={Urls.billing()} onClick={() => trackSettingsOpened('billing')} className={className}>
      {children}
    </Link>
  );
};
